/** Pola żądań przetargowych → etykiety widoczne dla użytkownika, żeby komunikat z DRF
 *  ("project_name: Ensure this field…") dało się przeczytać bez znajomości API. */
const FIELD_LABELS: Record<string, string> = {
  project_name: "Nazwa przedsięwzięcia",
  project_short_name: "Nazwa skrócona",
  coordinator_id: "Koordynator",
  planned_revenue: "Kwota netto",
  planned_revenue_date: "Planowana data",
  branch_name: "Oddział klienta",
  sub_branch_name: "Pododdział (rejon)",
  contract_file: "Umowa (PDF)",
  non_field_errors: "",
  detail: "",
};

/** Wyciąga czytelny komunikat z odpowiedzi błędu w kopercie `{ data, errors, meta }`.
 *  `errors` bywa stringiem (ręczne Response w widoku), obiektem `{detail: …}` albo
 *  słownikiem pól z walidacji DRF — obsługujemy wszystkie trzy kształty. */
export function extractTenderError(err: unknown): string {
  const res = (err as { response?: { status?: number; data?: { errors?: unknown } } })?.response;
  const errs = res?.data?.errors;

  if (typeof errs === "string" && errs.trim()) return errs;

  if (errs && typeof errs === "object") {
    const parts: string[] = [];
    for (const [field, value] of Object.entries(errs as Record<string, unknown>)) {
      const msg = (Array.isArray(value) ? value.map(String).join(" ") : String(value)).trim();
      if (!msg) continue;
      const label = FIELD_LABELS[field] ?? field;
      parts.push(label ? `${label}: ${msg}` : msg);
    }
    if (parts.length) return parts.join(" · ");
  }

  if (res?.status === 403) return "Brak uprawnień do tej operacji.";
  if (res?.status) return `Błąd serwera (HTTP ${res.status}). Spróbuj ponownie.`;
  return "Brak połączenia z serwerem. Spróbuj ponownie.";
}
